// imports
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Cookies from "universal-cookie";
// icon imports
import ValidIcon from "../../assets/images/register/green_check.svg";
import editIcon from "../../assets/images/register/edit.png";
// constant/utils import
import { deviceType } from "../../utils/registrationUtils";
import {gaEvent, gaLocationAndContentData} from "../../utils/index";
// component import
import CommonModal from "../utils/commonModal";
// action imports
import { clearUserLoginSignupOtpResponse } from "../../../store/slices/Registration/CommonSlices";

// Micro Component Wrapper
const MicroComponentWrapper = ({ component }) => component()

const CareersRegisterInputEmail = (props) => {

  // Destructured Props
  const {
    values,
    name,
    setFieldValue,
    validationSchema,
    errors,
    touched,
    handleBlur,
  } = props;

  const dispatch = useDispatch();
  const cookies = new Cookies();
  // state variables
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredDomains, setFilteredDomains] = useState([]);
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [show, setShow] = useState(false);
  const [blockMailDomains, setBlockMailDomains] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

 
  useEffect(() => {
    if (props.noButtonClikedEmail) handleEdit()
  }, [props.noButtonClikedEmail])


  // Render the email input field
  const emailInput = (props) => {
    return (
      <>
        <input
          type="text"
          name={name}
          value={values?.email}
          className="input_type_text"
          {...props}
        />
        <span className={values?.email ? 'floating_label_active' : 'floating_label'}>
          {'Email'}
        </span>
      </>
    )
  }

  const handleEdit = (e) => {
    gaEvent("otpchangemobilesignup", "login_signup", `${gaLocationAndContentData}`, "");
    props.dispatch(clearUserLoginSignupOtpResponse())

    setIsEditClicked(true);
    props.setEditEmail(true);
    props.setFormCurrentState((prev) => ({
      ...prev, isEmailEditing: true
    }))
    setTimeout(() => {
      if (props.mobileInputRef?.current) {
        props.mobileInputRef?.current.focus();
      }
    }, 10)
  }

  const handleInputChange = (e, name) => {
    let value = e.target.value;
    const emailValidations = /[^a-zA-Z0-9@_.-]|(\.{2,})|@.*@|\s{2,}|^_|_{2,}|[._-]{2,}|^\.|(\.@|_@)|^[\s]|[\s]$|@[^a-zA-Z0-9.]|@.*\.{4,}|@[.]{2,}|@.*_|^-|.*-@|@.*-/;
    const prevValue = values[name] ?? '';
    if (value && emailValidations.test(value)) {
      setFieldValue("email", prevValue);
      props.setSyncSignupValues((prev) => ({ ...prev, "email": prevValue }))
      value = prevValue;
      e.preventDefault();
      return;
    }
    if (value?.includes("@")) {
      const afterAt = value.split("@")[1];
      if (afterAt.startsWith(".") || afterAt.split(".").length - 1 >= 3 || afterAt.includes("@")) {
        e.preventDefault();
        return;
      }
    }
    setFieldValue("email", value);
    props.setSyncSignupValues((prev) => ({ ...prev, "email": value }))
    if (value) {
      if (value?.includes("@")) {
        setShow(true); // Show the modal (Mobile case)
        setHighlightedIndex(-1); // Reset highlighted index
        const domainPart = value.split("@")[1];
        const filtered = blockMailDomains?.filter((domain) =>
          domain?.startsWith(domainPart)
        );
        // Check if the typed domain is in the filtered domains
        if (filtered?.includes(domainPart) || value?.includes(".com")) {
          setShowDropdown(false);
        } else {
          setShowDropdown(true);
        }
        setFilteredDomains(filtered);
      }
      else {
        setShowDropdown(false);
      }
    }
  };

  const handleDropdownSelect = (domain) => {
    // Add the selected domain to the input value
    setFieldValue("email", values?.email?.replace(/@[^@]*$/, `@${domain}`));
    props.setSyncSignupValues((prev) => ({ ...prev, "email": values?.email?.replace(/@[^@]*$/, `@${domain}`) }))
    setShowDropdown(false); // Close the dropdown
    setShow(false); //close the modal
  };

  const handleFocus = () => {
    setIsSearch(true)
  }
  const handleIsFocused = () => {
    props.setIsEmailFocused(true)
    props.updateTouchedFields({ ...touched, [`${name}`]: true })
  }

  const editButton = () => {
    if (ConditionsSet?.showEditBtn) {
      return (
        <div onClick={handleEdit} className="edit_card">
          <img src={editIcon} alt="edit_icon" />
          <span>Edit</span>
        </div>
      )
    }
    return <></>
  }

  const validIcon = () => {
    if (window.location.href.includes("/user/register") && props.userAuthenticationEmailError?.authorization != false &&
      !errors.email && values?.email && !(!/^(?!.*\.{2})[a-zA-Z0-9._%+-]+@(?!\.)(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(values.email) || (values?.email?.split('@')?.[0] == '.') || (values?.email?.[0] == '.'))
      && !props.postSignupData?.message?.includes("email")) {
      return (
        <img
          src={ValidIcon}
          alt="careers_register_checkIcon"
          className="careers_register_valid_icon"
        />
      )
    }
    else if (window.location.pathname.includes("/user/otp-verify") && props.userAuthenticationEmail && !errors.email && values?.email && !props.userLoginSignupOtpError
      && (isEditClicked || props.formCurrentState?.isEmailEditing)) {
      return (
        <img
          src={ValidIcon}
          alt="careers_register_checkIcon"
          id="email_valid_icon"
          className="careers_register_valid_icon"
        />
      )
    }
    return <></>
  }

  const errorMessage = () => {
    if (errors.email && touched.email) {
      return (
        <div className="invalid_card">
          <span className="invalid_card_text">{errors.email}</span>
        </div>
      )
    }
    else if (props.postSignupData?.message?.includes("email")) {
      return (
        <div className="invalid_card">
          <span className="invalid_card_text">{props.postSignupData?.message}</span>
        </div>
      )
    }
    else if ((props.userAuthenticationEmailError?.authorization == false || props.userLoginSignupOtpError?.block_user_case == "user_restricted"
      || props.userLoginSignupOtpError?.block_user_case == "otp_exceed") && !errors.email) {
      return (
        <div className="invalid_card">
          {props.userAuthenticationEmailError?.block_user_case === "invalid_email_domain" ?
            <span className="invalid_card_text">{props.userAuthenticationEmailError?.message}</span> :
            <span className="invalid_card_text">Email error, <a href="https://www.careers360.com/grievance-redressal" className="contact_support_text">contact support</a></span>}
        </div>
      )
    }
    return <></>
  }

  const emailAutoComplete = (props) => {
    if (showDropdown) {
      return (
        <ul id={props?.id} className={values?.email?.includes(filteredDomains) ? "" : "careers_register_email_dropdown"}>
          {filteredDomains.map((domain, index) => (
            <li key={index} onClick={() => handleDropdownSelect(domain)} className={highlightedIndex === index ? 'email_dropdown_highlighted' : ''}>
              {domain}
            </li>
          ))}
        </ul>
      )
    }
  }

  useEffect(() => {
    if (props.emailDomainDatas) {
      const emailDomainsArray = props.emailDomainDatas?.values?.map(item => item.value) ?? [];
      const uniqueEmailDomains = [...new Set(emailDomainsArray)]; //to remove duplicate data
      setBlockMailDomains(uniqueEmailDomains);
    }

    const handleOutsideClick = (event) => {
      const dropdown = document.getElementById('emailDropdown');
      // Check if the click is outside the dropdown and input
      if (dropdown && !dropdown.contains(event.target) && event.target !== document.getElementById('emailInput')) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };

  }, [props.emailDomainDatas])

  useEffect(() => {
    if (props.userLoginSignupOtp) {
      setIsEditClicked(false);
    }
  }, [props.userLoginSignupOtp])

  useEffect(() => {
    const emailInput = document.getElementById('emailInput');
    const emailDropdown = document.getElementById('emailDropdown');

    const handleKeyDown = (event) => {
      const key = event.key;
      const options = emailDropdown?.querySelectorAll('li');
      const totalOptions = options?.length;

      if (key === 'ArrowUp' || key === 'ArrowDown') {
        event.preventDefault();
        if (key === 'ArrowUp') {
          setHighlightedIndex((prevIndex) => {
            if (prevIndex === -1) return totalOptions - 1; // If no selection, highlight the last option
            return (prevIndex - 1 + totalOptions) % totalOptions; // Move to the previous option
          });
        } else if (key === 'ArrowDown') {
          setHighlightedIndex((prevIndex) => {
            if (prevIndex === -1) return 0; // If no selection, highlight the first option
            return (prevIndex + 1) % totalOptions; // Move to the next option
          });
        }
        // Update highlighted class for dropdown options
        options.forEach((option, index) => option.classList.toggle('email_dropdown_highlighted', index === highlightedIndex));
      } else if (key === 'Enter') {
        event.preventDefault();
        if (highlightedIndex !== -1) {
          const selectedDomain = options[highlightedIndex]?.textContent;
          const filteredValue = selectedDomain.includes('@') ? selectedDomain.split('@')[0] : selectedDomain;
          emailInput.value = filteredValue;
          setFieldValue("email", emailInput.value.replace(/@[^@]*$/, selectedDomain)); // Set email value with selected domain
          handleDropdownSelect(selectedDomain);// Handle dropdown selection
          setShowDropdown(false);// Hide dropdown
        }
      }
    };

    if (emailInput && emailDropdown) {
      emailInput.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      if (emailInput && emailDropdown) {
        emailInput.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, [highlightedIndex, showDropdown]);

  const ConditionsSet = {
    borderError: (errors.email && touched.email) || props.postSignupData?.message?.includes("email")
      || props.userAuthenticationEmailError?.authorization == false || props.userLoginSignupOtpError?.block_user_case == "otp_exceed"
      || props.userLoginSignupOtpError?.block_user_case == "user_restricted",
    showEditBtn: (window.location.href.includes("/user/otp-verify") && values?.email && !errors.email && !props.editEmail && !props.formCurrentState?.isEmailEditing),
    showEditEmailInput: ((isEditClicked && props.editEmail) || props.formCurrentState?.isEmailEditing || props.userLoginSignupOtpError),
    isValidEmail: ((errors.email && touched.email) || props.postSignupData?.message?.includes("email") || props.userAuthenticationEmailError?.authorization == false),

  }

  return (
    <>
          {deviceType == "web" && (
        <div className={ConditionsSet?.borderError ? "careers_register_form_card text_input invalid_field" : values?.email ? "careers_register_form_card text_input white_bg" : "careers_register_form_card text_input"}>
              <MicroComponentWrapper
                component={() => emailInput({
                  id: "emailInput",
                  onBlur: handleBlur,
                  onChange: (e) => {
                    handleInputChange(e, name);
                  },
                  ref: ConditionsSet?.showEditEmailInput ? props.mobileInputRef : null,
                  onFocus: () => ConditionsSet?.showEditEmailInput && handleIsFocused(),
                  readOnly: ConditionsSet.showEditBtn ? true : false,
                })}
              />
          <MicroComponentWrapper component={editButton} />
          <MicroComponentWrapper component={validIcon} />
          <MicroComponentWrapper component={errorMessage} />
          <MicroComponentWrapper component={() => emailAutoComplete({ id: "emailDropdown" })} />

        </div>
      )}


      {deviceType == "mobile" && (
        <>
          <div className={ConditionsSet?.borderError ? "careers_register_form_card text_input invalid_field"
            : values?.email ? "careers_register_form_card text_input white_bg" : "careers_register_form_card text_input"}>
            <MicroComponentWrapper
              component={() => emailInput({
                value: values.email || cookies.get("registrationState")?.formValues?.email,
                onClick: () => setShow(ConditionsSet?.showEditBtn ? false : true),
                onChange: (e) => {
                  handleInputChange(e, name);
                },
                readOnly:true,
              })}
            />

            <MicroComponentWrapper component={validIcon} />
            <MicroComponentWrapper component={editButton} />
            <MicroComponentWrapper component={errorMessage} />

          </div>
          <CommonModal
            isOpen={show}
            closeModal={() => setShow(false)}
            classNames={{
              root: "mobile_modal mobile_modal_email",
              modal: 'custom_modal',
              // overlayAnimationIn: 'customEnterOverlayAnimation',
              // overlayAnimationOut: 'customLeaveOverlayAnimation',
              modalAnimationIn: 'customEnterModalAnimation',
              modalAnimationOut: 'customLeaveModalAnimation',
            }}
            animationDuration={800}
          >

            <div className={ConditionsSet?.isValidEmail ? "careers_register_form_card text_input invalid_field email_wrapper"
              : values?.email ? "careers_register_form_card text_input white_bg email_wrapper" : "careers_register_form_card text_input email_wrapper"}>
                  <MicroComponentWrapper
                    component={() => emailInput({
                      autoComplete: "off",
                      onBlur: handleBlur,
                      onKeyDown: (e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                        }
                      },
                      onChange: (e) => {
                        handleInputChange(e, name);
                      },
                      onFocus: () => { ConditionsSet?.showEditEmailInput ? (handleIsFocused(), handleFocus()) : handleIsFocused() },
                      readOnly: ConditionsSet?.showEditBtn? true : false,
                    })}
                  />

              <MicroComponentWrapper component={validIcon} />
              <MicroComponentWrapper component={emailAutoComplete} />
            </div>
            <div className="email_wap_done_cta_cover">
            <button onClick={() => setShow(false)} className="email_done_cta">Done</button>
            </div>
          </CommonModal>

        </>
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    emailDomainDatas: state.usersCommonData?.emailDomainData,
    userLoginSignupOtp: state.usersCommonData.userLoginSignupOtp,
    userLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
    postSignupData: state.userSignUpFields?.signupDataError,
    userAuthenticationEmail: state.usersCommonData?.userAuthenticationEmail,
    userAuthenticationEmailError: state.usersCommonData?.userAuthenticationEmailError,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareersRegisterInputEmail);

// uncomment if needed for edit email condition
 // Logic to show/hide edit button and email input field
  // let showEditBtn = (window.location.href.includes("/user/otp-verify") && values?.email
  //   && !errors.email
  //   && !props.editEmail && !props.formCurrentState?.isEmailEditing);
  // let showEditEmailInput = ((isEditClicked && props.editEmail) || props.formCurrentState?.isEmailEditing || props.userLoginSignupOtpError);
  // let isValidEmail = ((errors.email && touched.email) || props.postSignupData?.message?.includes("email") || props.userAuthenticationEmailError?.authorization == false);